/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { defineMessages } from 'react-intl';

import { fetchPost, fetchGet } from 'FetchAPIs';
import { I18NError } from 'Utils';
import { formatErrorResponse } from 'responseFormatterFunctions';

const baseDatalakeURL = '/api/datalake/data';

const messages = defineMessages({
  errorLoadingDevice: 'Error loading device data. {message}',
});

/**
 * Function  that loads details for a device
 * @returns device
 */
export const getDeviceDetails = async (deviceTypeId, deviceId) =>
  fetchGet(`${baseDatalakeURL}/deviceTypes/${deviceTypeId}/devices`, null, {
    deviceIds: deviceId,
  })
    .then(response => response)
    .catch(error => {
      throw new I18NError(messages.errorLoadingDevice, {
        message: formatErrorResponse(error),
      });
    });

/**
 * Function that loads devices details with dimensions and also support search/limit/page
 * @returns device
 */
export const getDeviceDetailsWithDimensions = async (
  deviceTypeId,
  limit = 100,
  userEmailId,
  body = {},
  offset = 0
) =>
  fetchPost(
    `${baseDatalakeURL}/deviceTypes/${deviceTypeId}/devices/search`,
    body,
    { userEmailId },
    { limit, offset }
  )
    .then(response => response)
    .catch(error => {
      throw new I18NError(messages.errorLoadingDevice, {
        message: formatErrorResponse(error),
      });
    });
